<template>
    <el-dialog
    title=""
    :visible.sync="linkOtherPlatformVisibility"
    :modal-append-to-body="false"
    :show-close='false'
    class="linkOtherPlatformDio"
    :close-on-click-modal='false'
    width="660px"
    center>
        <div class="delMsg-tit">
            Do you want to disconnect Doshii?
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="cancel" class="cardCanBtn">No</el-button>
            <el-button @click="confirm" class="cardConBtn" style="margin-left:10px">Yes</el-button>
        </span>
    </el-dialog>
</template>

<script>
import api from '../../api/api'
export default {
    props:['linkOtherPlatformVisibility'],
    data() {
        return {

        }
    },
    methods: {
        cancel(){
            this.$emit('close')
        },
        confirm(){
            api.delDoshiLink('',res=>{
                const {code,data,message} = res.data
                if(code === 0){
                    this.$emit('confirmDelDoshi')
                }else{
                    Utils.alert('',message,'error')
                }
            })
            this.cancel()
        }
    }
}
</script>

<style lang="scss" scoped>
.linkOtherPlatformDio{
	/deep/ {
        .el-dialog{
            background-color: var(--background-color-3) !important;
        }
        .el-dialog__header {
            padding: 0px 20px 10px;
        }
        .el-dialog--center .el-dialog__body {
            text-align: initial;
            padding: 40px 50px 30px;
        }
        .el-dialog__title{
            height:42px;
            font-size:30px;
            font-weight:600;
            color:var(--text-color);
            line-height:42px;
        }
        .cardCanBtn{
            width:280px;
            background:transparent;
            border:2px solid var(--text-color);
            color: var(--text-color);
            font-size:26px;
            font-weight: 600;
        }
        .cardConBtn{
            width:280px;
            background:transparent;
            border:2px solid var(--primary-color);
            color: var(--primary-color);
            font-size:26px;
            font-weight: 600;
            margin-left: 50px;
            margin-bottom:40px ;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/common/linkOtherPlatformDiolog.vue